 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/title-page'
 import FRONTISPIECE from '@/components/frontispiece'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import FOREWORD from '@/components/foreword'
 import PREFACE from '@/components/preface'
 import THEWATCHER from '@/components/the-watcher'
 import PASSAGEINTHESECRETHISTORYOFANIRISHCOUNTESS from '@/components/passage-in-the-secret-history-of-an-irish-countess'
 import STRANGEEVENTINTHELIFEOFSCHALKENTHEPAINTER from '@/components/strange-event-in-the-life-of-schalken-the-painter'
 import THEFORTUNESOFSIRROBERTARDAGH from '@/components/the-fortunes-of-sir-robert-ardagh'
 import THEDREAM from '@/components/the-dream'
 import ACHAPTERINTHEHISTORYOFATYRONEFAMILY from '@/components/a-chapter-in-the-history-of-a-tyrone-family'
 import LOVE_2 from '@/components/love_2'
 import PUBLISHERSNOTE from '@/components/publishers-note'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import ABOUTTHEILLUSTRATOR from '@/components/about-the-illustrator'
 import ABOUTTHEEDITOR from '@/components/about-the-editor'
 import WORDFIRECLASSICS from '@/components/wordfire-classics'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/preface",
 			"name" : "preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/the-watcher",
 			"name" : "the-watcher",
 			"component" : THEWATCHER
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js